import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';
import type { UserApi } from '@/modules/users/types';

import { usersQueryKeys } from './queryKeys';

export const useUsersQuery = (
  options?: Omit<
    UseQueryOptions<UserApi[] | undefined, unknown>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: usersQueryKeys.list(),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.users, {});
      return data;
    },
    ...options,
  });
};
